export default __webpack_public_path__ + "static/media/google-pin.aa143f51.svg";